import axios, { AxiosPromise } from 'axios';

const resource: string = `/painel-api/api/contratantes`;

export const findEmailDomain = (): AxiosPromise<string> => {
  return axios.get<string>(`${resource}/email-domain`);
};
